
<template>
  <!-- user-info-view .civ -->
  <div class="civ">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/host/index/home">首页</BreadcrumbItem>
          <BreadcrumbItem>供需审核</BreadcrumbItem>
          <BreadcrumbItem>用户供需审核</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">用户供需审核</div>
        <Input search placeholder="请输入关键字" v-model="searchField" @on-search="searchPro()" style="width:230px;margin-top:20px;" />

      </div>
    </div>
    <div class="header-switch">
      <div class="header-switch-text">对用户供需信息进行审核</div>
    </div>
    <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <TabPane label="待审核" name="1">
          <supplyUserCheck ref="supplyUserCheck" v-if="String(showTabs) === '1'" :searchField="searchField" />
        </TabPane>
        <TabPane label="未通过" name="2">
          <supplyUserPass ref="supplyUserPass" v-if="String(showTabs) === '2'" :searchField="searchField" />
        </TabPane>
      </Tabs>
    </div>
  </div>
</template>

<script>
import supplyUserCheck from "./subpages/supply-user-check.vue";
import supplyUserPass from "./subpages/supply-user-pass.vue";

export default {
  name: "host-supply-user",
  data () {
    return {
      searchField: "",
      showTabs: "1",
      show: false,
      allDone: "待处理",
    };
  },
  components: {
    supplyUserCheck,
    supplyUserPass,
  },
  created () {
    this.changeTab();
  },
  methods: {
    changeTab () {
      this.searchField = '';
      let query = this.$route.query;
      if (query && query.type && query.type === "check") {
        this.showTabs = "1";
      } else if (query && query.type && query.type === "pass") {
        this.showTabs = "2";
      }
    },
    switchBrand (name) {
      if (name === "1") {
        this.$router.push(`${this.$route.path}?type=check`);
      } else if (name === "2") {
        this.$router.push(`${this.$route.path}?type=pass`);
      }
    },
    showAdd (name) {
      this.$refs[name].showAdd();
    },
    searchPro () {
      if (this.showTabs === "1") {
        this.$refs.supplyUserCheck.reload();
      } else if (this.showTabs === "2") {
        this.$refs.supplyUserPass.reload();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.header-switch {
  display: flex;
  align-items: center;
  padding: 0 35px 18px 35px;
  background: #fff;
  &-text {
    flex: 1;

    font-size: 14px;
    color: #808080;
  }
  &-box {
    flex: 1;
    text-align: right;
  }
}
</style>
